import { render, staticRenderFns } from "./posapp.vue?vue&type=template&id=efee2f02&scoped=true"
import script from "./posapp.vue?vue&type=script&lang=js"
export * from "./posapp.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=efee2f02&prod&scoped=true&lang=css&external"
import style1 from "./posapp.vue?vue&type=style&index=1&id=efee2f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efee2f02",
  null
  
)

export default component.exports